module.exports = {"sld:ColorMapEntry":[{"color":"#0074ad","label":"< 1.66489","quantity":0.01665},{"color":"#9dc4b5","label":" 1.66489- 1.66489","quantity":0.01665},{"color":"#e6efc3","label":" 1.66489- 1.8465","quantity":0.01846},{"color":"#ffe89e","label":" 1.8465- 2.33179","quantity":0.02332},{"color":"#f5af7f","label":" 2.33179- 3.23977","quantity":0.0324},{"color":"#ed6d32","label":" 3.23977- 14.14365","quantity":0.14144}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/fxfl_raster/wheat_MME_1981_2016_lcr_70_return_20.json
// module id = PNrq
// module chunks = 171